"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Web3Helper {
    constructor(web3) {
        this.web3Client = web3;
    }
    sendTransactionAsync(dispatch, transactions, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const txIds = [];
            for (const tx of transactions) {
                const txId = yield new Promise((resolve, reject) => {
                    var _a;
                    return this.web3Client.eth
                        .sendTransaction({
                        from: tx.from,
                        to: tx.contract,
                        value: tx.value || "0x",
                        data: tx.data,
                        gas: (_a = tx.gas) === null || _a === void 0 ? void 0 : _a.gasLimit,
                        // gasPrice: tx.gas?.gasPrice,
                        // chainId: this.connection.netId()
                    })
                        // .on("confirmation", function (part1, part2) {
                        //   console.log("confirmation", part1, part2);
                        // })
                        .on("transactionHash", (transactionHash) => {
                        dispatch(transactionHash);
                    })
                        .then((h) => {
                        resolve(h);
                    })
                        .catch(reject);
                });
                // console.log(txId);
                txIds.push(txId.transactionHash);
            }
            // console.log(txIds, "txIdstxIds");
            return txIds.join(",") + "|" + JSON.stringify(payload || "");
        });
    }
}
exports.default = Web3Helper;
//# sourceMappingURL=Web3Helper.js.map